import { Checkbox } from "@progress/kendo-react-inputs";

export const IsRequiredProperty = {
  propertyName: "IsRequired",
  propertyDisplay: "Is Required?",
  propertyType: "boolean",
  propertyCategory: "Validation",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name={this.propertyName}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
